import { render, staticRenderFns } from "./BatchTranslateTemplateImageModal.vue?vue&type=template&id=74bdffff&scoped=true"
import script from "./BatchTranslateTemplateImageModal.vue?vue&type=script&lang=js"
export * from "./BatchTranslateTemplateImageModal.vue?vue&type=script&lang=js"
import style0 from "./BatchTranslateTemplateImageModal.vue?vue&type=style&index=0&id=74bdffff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bdffff",
  null
  
)

export default component.exports